import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isToday } from 'date-fns';
import { observer } from 'mobx-react';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { ButtonIconPosition } from '../../../subcomponents/button/types/icon-position';
import { Message } from '../../../subcomponents/message/message';
import { useI18n } from '../../occ/hooks/use-i18n';
export var ShowtimeContextMessageType;
(function (ShowtimeContextMessageType) {
    ShowtimeContextMessageType["FutureAdvanceBookingPeriod"] = "FutureAdvanceBookingPeriod";
    ShowtimeContextMessageType["FailedToLoadData"] = "FailedToLoadData";
})(ShowtimeContextMessageType || (ShowtimeContextMessageType = {}));
const b = bemClassBuilder('v-showtime-context-message');
export const ShowtimeContextMessage = observer(props => {
    const i18n = useI18n();
    const { displayText, events } = props;
    // TODO: Investigate if we should add a reload button. #311838
    return (_jsx(Message, Object.assign({ className: b.block() }, getMessageProps(props, i18n), { children: events.onMessageActionButtonClicked && (_jsx(Button, { color: ButtonColor.Primary, label: displayText.messageActionButtonLabel, iconPosition: ButtonIconPosition.Right, onClick: events.onMessageActionButtonClicked })) })));
});
ShowtimeContextMessage.displayName = 'ShowtimeContextMessage';
const getMessageProps = (props, i18n) => {
    const { displayText, assets } = props;
    switch (props.messageType) {
        case ShowtimeContextMessageType.FutureAdvanceBookingPeriod: {
            const bookingPeriodStartsAt = new Date(props.bookingPeriod.startsAt);
            const message = isToday(bookingPeriodStartsAt)
                ? displayText.futureAdvanceBookingPeriodTodayMessage
                : displayText.futureAdvanceBookingPeriodMessage;
            return {
                title: displayText.futureAdvanceBookingPeriodTitle,
                description: i18n.displayTextLabel(message, { bookingPeriodStartsAt }),
                iconName: assets.futureAdvanceBookingPeriodIconName
            };
        }
        case ShowtimeContextMessageType.FailedToLoadData:
        default:
            return {
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage,
                iconName: assets.failedToLoadDataIconName
            };
    }
};
